<template>
  <div :class="setBarClass()" class="p-4 rounded px-6 ">
    <h4> {{notification.message}} </h4>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    notification: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      timeout: null,
      timoutAnimation: null,
      exitAnimation: false,
    };
  },

  mounted() {
    this.timeout = setTimeout(() => this.removeNotificationWithTranslate(), 5000);
    this.timoutAnimation = setTimeout(() => this.setEndAnimation(), 4200);
  },

  beforeDestroy() {
    clearTimeout(this.timeout);
    clearTimeout(this.timoutAnimation);
  },

  methods: {
    ...mapActions({
      removeNotification: 'notification/remove',
    }),

    setEndAnimation() {
      this.exitAnimation = true;
    },

    removeNotificationWithTranslate() {
      this.removeNotification(this.notification);
      this.exitAnimation = false;
    },

    setBarClass() {
      let barClass = 'bg-yellow-500';
      if (this.notification.type === 'success') barClass = 'bg-green-600 text-green-100';
      if (this.notification.type === 'error') barClass = 'bg-b2c-red-300 text-b2c-grey-100';
      if (this.exitAnimation) barClass += ' hidden';
      if (!this.exitAnimation) barClass += ' animate-translate-out';
      return barClass;
    },
  },
};
</script>
